import { render } from "./AddFrontOffice.vue?vue&type=template&id=73e8e5eb&scoped=true"
import script from "./AddFrontOffice.vue?vue&type=script&lang=js"
export * from "./AddFrontOffice.vue?vue&type=script&lang=js"

import "./AddFrontOffice.vue?vue&type=style&index=0&id=73e8e5eb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73e8e5eb"

export default script